import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CollectionSkeleton } from "../components/CollectionSkeleton";
import { useAuth } from "../lib/useAuth";
import { pathAfterGuestDemo } from "../lib/after-auth";

let guestAutoLoginStarted = false;

/**
 * `#/guest` is the explicit "Open the demo as a guest" entry. It opts into the
 * sample and lands on the demo overview — unlike post-sign-in, which never
 * auto-opens the sample.
 */
export default function Guest() {
  const { isAuthenticated, loginAsGuest, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      guestAutoLoginStarted = false;
      const token = useAuth.getState().token;
      (async () => {
        const next = token ? await pathAfterGuestDemo(token) : "/data-sources";
        navigate(next);
      })();
      return;
    }
    if (guestAutoLoginStarted) {
      return;
    }
    guestAutoLoginStarted = true;
    loginAsGuest("")
      .then(async () => {
        guestAutoLoginStarted = false;
        const token = useAuth.getState().token;
        const next = token ? await pathAfterGuestDemo(token) : "/data-sources";
        navigate(next);
      })
      .catch(() => {
        guestAutoLoginStarted = false;
      });
  }, [isAuthenticated, loginAsGuest, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-od-bg flex items-center justify-center px-4">
        <p className="text-od-text text-sm">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-od-bg">
      <CollectionSkeleton />
    </div>
  );
}
